import './App.css';
import Header from './Header';
import Main from './Main';

export default function App() {
  return (
    <div className="App">
       <Header/>
       <Main/>
    </div>
  );
}


